export  const bid  = [
    "Has been competitively Bid",
    "Will  be competitively Bid",
    "Will not be competitively Bid"
]